/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePassword } from '../models/ChangePassword';
import type { User } from '../models/User';
import type { UserSettingsLanguage } from '../models/UserSettingsLanguage';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UserService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * @returns void
     * @throws ApiError
     */
    public userChangePassword({
        requestBody,
    }: {
        requestBody: ChangePassword,
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/user/change-password',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @returns User
     * @throws ApiError
     */
    public userMeRetrieve(): CancelablePromise<User> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/user/me',
        });
    }
    /**
     * @returns UserSettingsLanguage
     * @throws ApiError
     */
    public userUpdateSettings({
        requestBody,
    }: {
        requestBody?: UserSettingsLanguage,
    }): CancelablePromise<UserSettingsLanguage> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/api/user/settings',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
